<div class="container">
    <!-- [ngClass]="{ 'border-radius-none': statusTab === 1 }" -->
    <div class="header__row">
        <div *ngIf="!isMobile" class="dms__message">
			<span class="dms__message-warning">Внимание !</span> Запись на
			услуги ДМС производится только через Контакт Центр. Просьба
			обращаться по телефону: 519-000.
        </div>
		<div *ngIf="isMobile" class="dms__message-mobile">
			<span class="dms__message-warning">Внимание !</span> Запись на
			услуги ДМС производится только через Контакт Центр. Просьба
			обращаться по телефону: 519-000.
		</div>
        <div class="header_tags-filial">
            <span *ngIf="!isMobile" class="header__label-filial"
                >Запись к врачу</span
            >
            <div
                class="header__tabs"
                [ngClass]="{ 'tab-right': statusTab == 1 }"
                *ngIf="isFilialMode"
            >
                <button
                    class="toggle-btn toggle-btn-left"
                    [ngClass]="{ 'toggle-active': statusTab == 0 }"
                    (click)="changeTab(0)"
                >
                    <div class="cls-icon-menu-item">
                        <mat-icon
                            class="cls-icon-menu-item"
                            svgIcon="hotel"
                            style="
                                width: auto;
                                height: 1.5rem;
                                min-height: 1.5rem;
                            "
                        ></mat-icon>

                        <!-- Icon placeholder -->
                    </div>
                    <span class="toggle-btn-left-text">
                        {{ isMobile ? "Филиалы" : "По филиалу" }}</span
                    >
                </button>
                <button
                    class="toggle-btn toggle-btn-right"
                    [ngClass]="{ 'toggle-active': statusTab == 1 }"
                    (click)="changeTab(1)"
                >
                    <div class="cls-icon-menu-item">
                        <!-- Icon placeholder -->
                        <mat-icon
                            class="cls-icon-menu-item"
                            svgIcon="user-doctor-solid"
                            style="
                                width: auto;
                                height: 1.5rem;
                                min-height: 1.5rem;
                            "
                        ></mat-icon>
                    </div>
                    <span class="toggle-btn-left-text">
                        {{
                            isMobile ? "Специальности" : " По специальности"
                        }}</span
                    >
                </button>
            </div>
        </div>
        <div
            class="filter-wrapper"
            (click)="toggleSearchList($event)"
            *ngIf="
                statusTab === 1 ||
                (isFilialMode &&
                    (_filialList.length >= 6 ||
                        (selectedFilial && specByFilialList.length > 0)))
            "
        >
            <!-- *ngIf=" (!isMobile && _filialList.length > 6) || (!isMobile &&
            selectedFilial) " -->
            <mat-icon
                svgIcon="search"
                class="cls-btn-icon icon-search"
            ></mat-icon>
            <input
                type="text"
                class="rec-searsh-spec"
                [placeholder]="
                    statusTab == 0 && !selectedFilial
                        ? 'Выберите филиал'
                        : 'Выберите специализацию'
                "
                #InputBlocSpec
                [(ngModel)]="searchStr"
                (ngModelChange)="changeSearch($event)"
            />
            <button
                class="clear-filter-btn"
                (click)="clearSearch($event)"
                *ngIf="searchStr.length > 0"
            >
                <img
                    src="./assets/img/svg/cross.svg"
                    alt="Clear"
                    width="16px"
                    height="16px"
                />
            </button>

            <!-- //меню для телефона -->
            <div
                class="mobile-dropdown"
                *ngIf="
                    !selectedSpec &&
                    staticFilterBTNs.length > 0 &&
                    statusTab === 1
                "
            >
                <button
                    class="mobile-filter__button"
                    (click)="mobileFilterHandler()"
                    [ngClass]="{ 'border-active': staticFilterSelected }"
                >
                    <img
                        src="./assets/img/svg/filters.svg"
                        alt="filter"
                        [ngClass]="{ 'border-active': staticFilterSelected }"
                        class="mobile-filter__button-swg"
                        *ngIf="!staticFilterSelected"
                    />
                    <img
                        src="./assets/img/svg/filtersAccept.svg"
                        alt="filterAccepted"
                        [ngClass]="{ 'border-active': staticFilterSelected }"
                        class="mobile-filter__button-swg"
                        *ngIf="staticFilterSelected"
                    />
                </button>
                <div class="dropdown-menu" *ngIf="isMobileFlilterOpen">
                    <app-filter-component
                        [staticFilterSelected]="staticFilterSelected"
                        [filterList]="staticFilterBTNs"
                        (filterChanged)="onFilterChanged($event)"
                        (closeFilter)="isMobileFlilterOpen = false"
                        [searchAmine]="searchAmine"
                        class="dropdown-menu"
                    ></app-filter-component>
                </div>
            </div>
        </div>
    </div>

    <div class="content-filial" *ngIf="statusTab == 0">
        <div class="header_tags" *ngIf="selectedFilial || selectedSpec">
            <span class="header__label">
                <ng-container *ngIf="selectedFilial && selectedSpec">
                    <span class="clickable-tag" (click)="goBackToFilial()">{{
                        selectedFilial.dep_name
                    }}</span>
                    <span class="tag-separator">
                        <mat-icon
                            svgIcon="next-step"
                            class="next-step"
                        ></mat-icon>
                    </span>
                    <span class="clickable-tag" (click)="clearSelection()">{{
                        selectedSpec.text
                    }}</span>
                </ng-container>
                <ng-container *ngIf="selectedSpec && !selectedFilial">
                    <span class="clickable-tag" (click)="clearSelection()">{{
                        selectedSpec.text
                    }}</span>
                </ng-container>
                <ng-container *ngIf="selectedFilial && !selectedSpec">
                    <span class="clickable-tag" (click)="goBackToFilial()">{{
                        selectedFilial.dep_name
                    }}</span>
                </ng-container>
                <!-- <ng-container *ngIf="!selectedFilial && !selectedSpec">
                    Филиалы
                </ng-container>-->
            </span>
        </div>

        <!-- <div *ngIf="loadingListFil"> -->
        <div
            *ngIf="loadingListFil && !filialList.length"
            class="loader-container"
        >
            <loader type="page"> </loader>
        </div>
        <!-- </div> -->

        <div class="rec-content" *ngIf="!loadingListFil">
            <!-- [@expandedAnimation]="searchAmine" -->
            <!-- *ngIf="
                    isFilialListVisible &&
                    isSearchListVisible &&
                    filialList.length !== 0 &&
                    statusTab === 0
                " -->
            <div
                class="search-list filial-list"
                (click)="$event.stopPropagation()"
                *ngIf="
                    isFilialListVisible &&
                    filialList.length !== 0 &&
                    !selectedFilial
                "
                [class.slide-top]="isSearchListVisible"
                [class.slide-down]="!isSearchListVisible"
            >
                <div
                    class="search-list-item"
                    *ngFor="let fl of filialList"
                    (click)="selectFil(fl.dep_id)"
                >
                    <img
                        class="search-list-item-img"
                        [src]="getImgSrcFilials()"
                        (error)="errorHandlerIMG($event, 'filial')"
                    />
                    <span class="search-list-item-text">{{ fl.dep_name }}</span>
                </div>
            </div>

            <div
                *ngIf="loadingListDepSpec && !specByFilialList.length"
                class="loader-container"
            >
                <loader type="page"> </loader>
            </div>
            <!-- </div> -->

            <div
                class="search-list float-up-animation"
                (click)="$event.stopPropagation()"
                *ngIf="
                    selectedFilial &&
                    !loadingListDepSpec &&
                    !openMobileTemplate &&
                    specByFilialList.length !== 0 &&
                    isSearchListVisible
                "
                [class.slide-top]="isSearchListVisible"
                [class.slide-down]="!isSearchListVisible"
            >
                <div
                    class="search-list-item"
                    *ngFor="let sfl of specByFilialList"
                    (click)="selectSpec(sfl.keyid, sfl.depid)"
                >
                    <img
                        class="search-list-item-img"
                        [src]="getImgSrcSpec(sfl.keyid)"
                        (error)="errorHandlerIMG($event, 'spec')"
                    />
                    <span class="search-list-item-text">{{ sfl.text }}</span>
                </div>
            </div>

            <div
                class="spec-list-emply"
                *ngIf="
                    (specByFilialList.length === 0 &&
                        !loadingListDepSpec &&
                        searchStr.length > 0) ||
                    (specByFilialList.length === 0 &&
                        !loadingListDepSpec &&
                        !loadingComplite) ||
                    (specByFilialList.length === 0 &&
                        selectedFilial &&
                        !loadingListDepSpec)
                "
            >
                Список пуст

                <div
                    class="return-to-filials"
                    (click)="
                        selectedFilial && searchStr.length !== 0
                            ? clearSearch()
                            : goBackToFilial()
                    "
                >
                    Вернуться к списку
                    {{
                        selectedFilial &&
                        specByFilialList.length === 0 &&
                        searchStr.length !== 0
                            ? "специальностей"
                            : "филиалов"
                    }}
                </div>
            </div>

            <!-- <div *ngIf="loadingListDoc"> -->
            <div *ngIf="loadingListDoc" class="loader-container">
                <loader type="page"> </loader>
            </div>
            <!-- </div> -->

            <div class="doctors" *ngIf="selectedSpec && !loadingListDoc">
                <ng-container *ngFor="let doctor of recDoctors">
                    <app-doctor-card
                        *ngIf="!isDropdownOpen"
                        [doctor]="doctor"
                        [isActive]="doctor === activeItem"
                        [openSelectStates]="openSelectStates"
                        [selectedSrvMap]="selectedSrvMap"
                        [searchStrSrv]="searchStrSrv"
                        (serviceSelected)="selectService($event)"
                        (toggleSelectEvent)="handleToggleSelect($event)"
                        (searchSrvChanged)="handleSearchSrvChanged($event)"
                        (openDocInfo)="handleOpenDocInfo($event)"
                        (openServDesc)="handleOpenServDesc($event)"
                        (pickDoc)="pickDoc($event)"
                        style="display: block; width: 100%"
                        [isMobile]="isMobile"
                    ></app-doctor-card>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="content-spec" *ngIf="statusTab == 1">
        <div class="header__row" *ngIf="!isMobile">
            <div class="header_tags">
                <button
                    class="cls-btn-filter"
                    *ngFor="let fl of staticFilterBTNs"
                    (click)="btnStaticFiltr(fl); $event.stopPropagation()"
                    [ngClass]="{
                        'cls-btn-filter-active':
                            fl.keyid === staticFilterSelected
                    }"
                    [disabled]="loadingListSpec"
                >
                    <span class="no-wrap">{{ fl.text }}</span>
                </button>
            </div>
        </div>

        <div
            class="loader-container"
            *ngIf="loadingListSpec && !specList.length"
        >
            <div *ngIf="loadingListSpec">
                <loader type="page"> </loader>
            </div>
        </div>

        <div class="rec-content">
            <!-- *ngIf="!openMobileTemplate" -->

            <div
                class="search-list"
                (click)="$event.stopPropagation()"
                *ngIf="
                    isSearchListVisible &&
                    specList.length !== 0 &&
                    statusTab === 1
                "
                [class.slide-top]="isSearchListVisible"
                [class.slide-down]="!isSearchListVisible"
            >
                <div
                    class="search-list-item"
                    *ngFor="let sl of specList"
                    (click)="selectSpec(sl.keyid, null)"
                >
                    <img
                        class="search-list-item-img"
                        [src]="getImgSrcSpec(sl.keyid)"
                        (error)="errorHandlerIMG($event, 'spec')"
                    />
                    <span class="search-list-item-text">{{ sl.text }}</span>
                </div>
            </div>

            <div
                class="spec-list-emply"
                *ngIf="
                    specList.length === 0 && !loadingListSpec && statusTab === 1
                "
            >
                Список пуст
            </div>

            <div
                class="loader-container"
                *ngIf="
                    loadingListDoc &&
                    !isSearchListVisible &&
                    !isFilialListVisible
                "
            >
                <!-- <div *ngIf="loadingListDoc"> -->
                <loader type="page"> </loader>
                <!-- </div> -->
            </div>
            <!-- && !openMobileTemplate -->
            <div class="doctors" *ngIf="selectedSpec && !loadingListDoc">
                <ng-container
                    *ngFor="let doctor of recDoctors"
                    class="doctors__card"
                >
                    <app-doctor-card
                        *ngIf="!isDropdownOpen"
                        [doctor]="doctor"
                        [isActive]="doctor === activeItem"
                        (serviceSelected)="selectService($event)"
                        [openSelectStates]="openSelectStates"
                        [selectedSrvMap]="selectedSrvMap"
                        [searchStrSrv]="searchStrSrv"
                        (toggleSelectEvent)="handleToggleSelect($event)"
                        (searchSrvChanged)="handleSearchSrvChanged($event)"
                        (openDocInfo)="handleOpenDocInfo($event)"
                        (openServDesc)="handleOpenServDesc($event)"
                        (pickDoc)="pickDoc($event)"
                        style="display: block; width: 100%"
                        [isMobile]="isMobile"
                    ></app-doctor-card>
                </ng-container>
                <!-- <div *ngIf="loadingListDoc" class="loading">
                    <loader type="page"> </loader>
                </div> -->
            </div>
        </div>
    </div>
</div>

<div *ngIf="showMobileServiceList && isMobile" class="doctor__srvlist">
    <rec-mobile-docsrv-list
        class="doctor__srvlist"
        [srvList]="selectedDoctor?.srvlist || []"
        (srvChanged)="srvChanged($event)"
        (closeSrvList)="closeMobileServiceList()"
    ></rec-mobile-docsrv-list>
</div>

<div *ngIf="showMobilePicker && isMobile" class="mobile-template">
    <app-mobile-appointment
        [params]="paramsTalonpicker"
        (talonPickerClosed)="onTalonPickerClosed()"
    ></app-mobile-appointment>
</div>
<!-- *ngIf="showCalendar" -->
<div
    *ngIf="showCalendar || loadingCalendar"
    class="cls-date-rnum"
    [class.visible]="showCalendar"
>
    <!-- <div *ngIf="loadingCalendar" class="loader-wrapper">
        <loader type="page"></loader>
    </div> -->

    <app-talonpicker
        #talonPicker
        *ngIf="showCalendar"
        [params]="paramsTalonpicker"
        (talonPickerClosed)="onTalonPickerClosed()"
    ></app-talonpicker>
</div>
